(() => {
  document.querySelectorAll('.nav-dropdown').forEach(dropdown=>{
    const trigger=dropdown.querySelector(':scope > a');
    const panel=dropdown.querySelector('.mega-menu,.help-menu');
    if(!trigger||!panel)return;
    const expand=()=>{dropdown.classList.remove('is-dismissed');trigger.setAttribute('aria-expanded','true');};
    dropdown.addEventListener('mouseenter',expand);
    dropdown.addEventListener('mouseleave',()=>{if(!dropdown.contains(document.activeElement))trigger.setAttribute('aria-expanded','false');});
    dropdown.addEventListener('focusin',()=>{if(!dropdown.classList.contains('is-dismissed'))trigger.setAttribute('aria-expanded','true');});
    dropdown.addEventListener('focusout',event=>{if(!dropdown.contains(event.relatedTarget)){dropdown.classList.remove('is-dismissed');trigger.setAttribute('aria-expanded','false');}});
    dropdown.addEventListener('keydown',event=>{
      if(event.key==='Escape'){event.preventDefault();dropdown.classList.add('is-dismissed');trigger.setAttribute('aria-expanded','false');trigger.focus();}
      else if(event.target===trigger&&event.key==='ArrowDown'){event.preventDefault();expand();panel.querySelector('a')?.focus();}
      else if(event.target===trigger&&event.key==='Tab'&&!event.shiftKey)expand();
    });
  });
  const menus=[...document.querySelectorAll('.header-localization,.header-search')];
  menus.forEach(menu=>menu.addEventListener('toggle',()=>{if(menu.open)menus.filter(other=>other!==menu).forEach(other=>other.open=false);}));
  document.addEventListener('click',event=>menus.forEach(menu=>{if(menu.open&&!menu.contains(event.target))menu.open=false;}));
  document.addEventListener('keydown',event=>{if(event.key==='Escape')menus.filter(menu=>menu.open).forEach(menu=>{menu.open=false;menu.querySelector('summary')?.focus();});});
  const input=document.querySelector('#HeaderSearch');const results=document.querySelector('#HeaderSearchResults');
  if(!input||!results)return;
  let debounce,controller,version=0;
  const setVisible=visible=>{results.hidden=!visible;input.setAttribute('aria-expanded',String(visible));};
  input.addEventListener('input',()=>{
    clearTimeout(debounce);controller?.abort();const current=++version;const query=input.value.trim();
    if(!query){results.replaceChildren();setVisible(false);return;}
    setVisible(true);results.textContent='Searching…';
    debounce=setTimeout(async()=>{
      controller=new AbortController();
      const params=new URLSearchParams({q:query,'resources[type]':'product','resources[limit]':'5',section_id:'mirumi-predictive-search'});
      try{
        const root=window.Shopify?.routes?.root||'/';
        const response=await fetch(root+'search/suggest?'+params,{signal:controller.signal});
        if(!response.ok)throw new Error('Search unavailable');
        const html=await response.text();if(current!==version)return;
        const parsed=new DOMParser().parseFromString(html,'text/html');
        const section=parsed.querySelector('#shopify-section-mirumi-predictive-search');
        if(!section||!section.textContent.trim())throw new Error('Empty search response');
        results.innerHTML=section.innerHTML;
      }catch(error){if(error.name!=='AbortError'&&current===version)results.textContent='Live search is unavailable. Press SEARCH to see results.';}
    },180);
  });
  input.addEventListener('keydown',event=>{if(event.key==='ArrowDown'&&!results.hidden){const first=results.querySelector('a');if(first){event.preventDefault();first.focus();}}});
  results.addEventListener('keydown',event=>{
    if(!['ArrowUp','ArrowDown'].includes(event.key))return;
    const links=[...results.querySelectorAll('a')];const index=links.indexOf(document.activeElement);if(index<0)return;
    event.preventDefault();const next=index+(event.key==='ArrowDown'?1:-1);if(next<0)input.focus();else links[Math.min(next,links.length-1)]?.focus();
  });
})();
